import acComposeMessage from './ac-compose-message.vue'

export default acComposeMessage
